import { render } from "./PersonalitiesScienceInterests.vue?vue&type=template&id=798c443c"
import script from "./PersonalitiesScienceInterests.vue?vue&type=script&lang=js"
export * from "./PersonalitiesScienceInterests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__